import { Component, OnInit , ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ChequereceiptService } from "../shared/chequereceipt.service";

@Component({
  selector: 'app-chequereceiptlist',
  templateUrl: './chequereceiptlist.component.html',
  styleUrls: ['./chequereceiptlist.component.css']
})
export class ChequereceiptlistComponent implements OnInit {

  displayedColumns: string[] = ['Date','Customer', 'ChequeNo', 'BankDetails', 'Amount', 'Branch', 'New'];
  ChequeList$ = [''];
  dataSource = new MatTableDataSource<any>();
 @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  constructor(private router: Router, private chequereceiptService: ChequereceiptService) { }

  ngOnInit() {
    this.getChequeList();
  }

  getChequeList() {
    this.chequereceiptService.FetchChequeReceiptList().subscribe(data => {
      // this.ChequeList$=data;
      this.dataSource.data = data;
    })
  }

  public AddNewChequeReceipt() {
    this.router.navigate(['/chequereceipt']);
  }

  EditChequeReceipt(chequeNo: any) {
    this.router.navigate(['/chequereceipt', chequeNo.Id]);
  }
}
